import "babel-polyfill";
import "es6-promise/auto";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ClickOutside from "vue-click-outside";
import VueAwesomeSwiper from "vue-awesome-swiper";
import moment from "moment";
import { Loading } from "element-ui";
import VueGtag from 'vue-gtag'
import "@/styles/common.scss";
import i18n from "./lang";
import ProgressBar from 'vuejs-progress-bar'

// import { mapState } from "vuex";
// import "element-ui/lib/theme-chalk/index.css";

export const eventBus = new Vue();
Vue.config.productionTip = true;

Vue.use(VueGtag, {
  config: {
    id: 'G-QWXTRQP8LP'  // Google Analytics의 Tracking ID를 넣어준다
  }
});
Vue.use(Loading);
Vue.use(Loading.directive);
Vue.use(eventBus);
Vue.use(moment);
Vue.use(ClickOutside);
Vue.use(VueAwesomeSwiper);
Vue.use(ProgressBar)
Vue.prototype.$loading = Loading.service;

new Vue({
  router,
  store,
  i18n,
  beforeCreate() {
    if (this.$store.state.isLogin) {
      this.$store.dispatch("getAccountInfo");
    }
  },
  render: h => h(App)
}).$mount("#app");
